const mapSuggestedAddress = suggestion => {
  return {
    line_1: suggestion.line_1,
    line_2: suggestion.line_2,
    house_number: suggestion.house_number,
    postcode: suggestion.postcode,
    locality: suggestion.locality,
    province: suggestion.province,
  }
}

export const transformRequestValidateAddress = ({ orderId, returnId, address, deliveryMethodId }) => {
  return {
    orderId,
    returnId,
    payload: { address, delivery_method_id: deliveryMethodId },
  }
}

export const transformResponseAddressValidation = validation => {
  return {
    valid: validation.valid,
    error_codes: validation.error_codes,
    suggestion: validation.suggestion ? mapSuggestedAddress(validation.suggestion) : null,
  }
}
